import { render, staticRenderFns } from "./FAButtons.vue?vue&type=template&id=c025dbfc&scoped=true"
import script from "./FAButtons.vue?vue&type=script&lang=js"
export * from "./FAButtons.vue?vue&type=script&lang=js"
import style0 from "./FAButtons.vue?vue&type=style&index=0&id=c025dbfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c025dbfc",
  null
  
)

export default component.exports